import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  StatusFormatter,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

// MUI
import {
  makeStyles,
  fade,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { FormHelperText, InputAdornment } from "@material-ui/core";

import {
  addUploadFile,
  addVehicle,
  addVehicleUpload,
  fetchIdInbound,
} from "./inboundSlice";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { id } from "date-fns/locale";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const VehicleUpload = ({
  isOpen,
  setShow,
  fileName,
  setFileName,
  file,
  setFile,
  setTableData,
  tableData,
  id,
  selectedRows,
  setSelectedRows,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClose = () => {
    setFileName("Upload Template File ");
    setFile(null);
    setShow(false);
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Master Code",
      dataField: "master_code",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Model Code",
      dataField: "model_code",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Color Code",
      dataField: "color_code",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Validation Result",
      dataField: "validate_file",
      sort: true,

      headerAlign: "center",
    },
  ];

  

  const handleSave = async () => {
    // if (file) {
    //   showErrorDialog("Please Input");
    // }

    const params = {
      id: id,
      file: file,
    };

    try {
      const response = await dispatch(addUploadFile(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await setShow(false);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleProses = async () => {
    if (selectedRows.length < 1) {
      return showErrorDialog("Please Select");
    }

    const params = selectedRows.map((item, index) => {
      return {
        ...item,
        inbound_id: id,
      };
    });

    try {
      const response = await dispatch(addVehicleUpload(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
        await setShow(false);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const onSelectRow = {
    mode: "checkbox",
    onSelectAll: (status) => {
      if (status === true) {
        setSelectedRows(tableData);
      } else {
        setSelectedRows([]);
        return false;
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isOpen}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter text-white">
          Upload Vehicle
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-5">
          <h5 className="font-weight-boldest">File</h5>

          <Row>
            <Col xs={12} sm={3} md={6} lg={6}>
              <Form.File
                type="file"
                id="file_fpre"
                custom
                label={fileName}
                onChange={(e) => {
                  setFile(e.target.files[0]);
                  setFileName(e.target.files[0].name);
                }}
                accept=".xlsx, .XLSX"
              />
            </Col>
            <Col>
              <Button variant="primary" onClick={handleSave}>
                Upload
              </Button>
            </Col>
          </Row>
        </div>

        {tableData.length > 0 && (
          <>
            <Row className="mt-6 justify-content-end">
              <Button variant="primary" onClick={handleProses}>
                Process Selected Vehicle(s)
              </Button>
            </Row>

            <div
              className="card-body pt-0   "
              style={{
                maxHeight: "550px",
                overflowY: "scroll",
              }}
            >
              <ToolkitProvider
                keyField="vehicle_id"
                data={tableData}
                columns={columns}
                search
              >
                {(props) => (
                  <div>
                    <Row>
                      <Col>
                        {/* <div className="float-right">
                              <SearchBar
                                {...props.searchProps}
                                placeholder="Search .."
                              />
                            </div> */}
                      </Col>
                    </Row>

                    <hr />
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      
                      selectRow={onSelectRow}
                      {...props.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
